export default __webpack_public_path__ + "static/0259-fb146fddb4fd103fe600153218dd8053.png";